import { FC } from 'react'
import { Poi } from '@/js/types'
import { Save } from 'lucide-react'

type PoiItemProps = {
    poi: Poi
    active: boolean
    action: (poi: Poi) => void
    onHover?: (poi: Poi) => void
    flagged?: string
}

export const PoiItem: FC<PoiItemProps> = ({ poi, active, action, onHover, flagged }) => {
    return (
        <div
            id={`poi_listing_item_${poi.id}`}
            role={'button'}
            className={`flex flex-row py-2 px-2 justify-between items-center  my-1 mx-2 rounded-md hover:bg-mm-bg2 ${active ? 'bg-mm-bg2 font-semibold' : ''}`}
            onClick={() => action(poi)}
            onMouseEnter={() => onHover(poi)}
        >
            <h3
                className={'text-sm! font-normal! text-black! m-0! tracking-normal!'}
                style={{
                    fontFamily: '"Helvetica Neue", Arial, Helvetica, sans-serif',
                }}
            >
                {poi.title}
            </h3>
            {flagged && (
                <span
                    className={
                        'flex items-center justify-center rounded-md text-xs text-white size-5 font-semibold bg-red-300'
                    }
                >
                    <Save size={16} />
                </span>
            )}
        </div>
    )
}
